import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation,
} from "@angular/core";

import { ChangeDetectorRef } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { Observable, Subscription } from "rxjs";
import { delay, filter } from "rxjs/operators";
import { environment } from "../environments/environment";
import {
  AccountService,
  PhodaFormsService,
  ScoreService,
} from "../swagger/api.client.generated";
import { UserService } from "./authentication/user.service";
import { ZoomService } from "./common/action-menu/zoom/zoom.service";
import { CardLocalService } from "./common/card/card.service";
import { ToolbarService } from "./common/toolbar/toolbar.service";
import { HomeService } from "./pages/home/home.service";
import { FeatureFlagService } from "./services/feature-flag.service";
import { SettingsLocalService } from "./pages/settings/settings.service";
import { WebPushSubscriptionService } from "./pages/settings/webpush-subscription.service";
import { A2hsService } from "./services/a2hs.service";
import { LoadingService } from "./services/loading.service";
import { MobileService } from "./services/mobile.service";
import { NativeBridgeService } from "./services/native-bridge.service";
import { NativePushNotificationService } from "./services/native-push-notification.service";
import { PageService } from "./services/page.service";
import { SharedService } from "./services/shared.service";
import { VersionCheckService } from "./services/version-check.service";
import { CardScaleService } from "./services/card-scale.service";
import { ImagePreloadService } from "./services/image-preload.service";
import { PaymentsService } from "./services/payments.service";
import { ScoreLocalService } from "./pages/score/score.service";
import { CommunityBridgeService } from "./services/community-bridge.service";
import { CommunityWarmupService } from "./services/community-warmup.service";
import { CommunityPromoModalService } from "./services/community-promo-modal.service";
import { CM01CommunityWelcomeService } from "./services/onboarding-lessons/cm01-community-welcome.service";
import { UpdateCompleteModalService } from "./services/update-complete-modal.service";
import { BackNavigationService } from "./services/back-navigation.service";
import { NovaNavigationContextService } from "./services/nova-navigation-context.service";
import { NovaWalkthroughService } from "./services/nova-walkthrough.service";
import { DialogNotificationService } from "./common/dialog-notifications/dialog-notifications.service";
import { isAppPath, notificationTypeFromUrl } from "./core/push-navigation";
import { APP_INSIGHTS_EXCLUDED_FROM_AUTO_TRACKING } from "./services/application-insights.service";
import { TrackingDispatchService } from "./services/tracking-dispatch.service";
import { RouterNavigationTrackerService } from "./services/router-navigation-tracker.service";
import { UserActivityService } from "./services/user-activity.service";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  formUserCompletionService: Subscription;
  isLoading: boolean = false;

  sub = "sub here";
  tests = "tests here";
  error = "error here";
  logo = "./assets/menu-logo-2.png";
  title = "Brain Changer";

  // mobileQuery: MediaQueryList;

  isFlutterInAppWebViewReady = false;
  isPlanPage: boolean = false;
  isMobileApp$: Observable<boolean>;
  subscription$: Subscription = new Subscription();

  // One-shot guard so the authenticated data fan-out runs once per confirmed session.
  private authedDataLoaded = false;

  /**
   * Tracks whether the previous NavigationEnd was inside /community, so the open/close
   * signal to the native app shell can be driven from URL transitions rather than
   * CommunityComponent's own ngOnInit/ngOnDestroy - those only fire once per app session
   * now that CommunityRouteReuseStrategy keeps it alive across navigation instead of
   * destroying/recreating it on every visit.
   */
  private wasInCommunity = false;

  // formUserCompletion: FormUserCompletionResponse =
  //   new FormUserCompletionResponse();

  // TODO - looks like the below variables are not needed
  showNotify: boolean = false;
  serviceWorkerEnabled: boolean = false;
  notificationsEnabled: boolean = false;

  constructor(
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    public router: Router,
    public a2hs: A2hsService,
    private pageService: PageService,
    private settingsLocalService: SettingsLocalService,
    private cardService: CardLocalService,
    private scoreService: ScoreService,
    private toolbarService: ToolbarService,
    private zoomService: ZoomService,
    private cardScaleService: CardScaleService,
    private homeService: HomeService,
    private featureFlagService: FeatureFlagService,
    private phodaFormsService: PhodaFormsService,
    private sharedService: SharedService,
    private loadingService: LoadingService,
    private accountService: AccountService,
    private mobileService: MobileService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private webPushSubscriptionService: WebPushSubscriptionService,
    private nativePushNotificationService: NativePushNotificationService,
    private imagePreloadService: ImagePreloadService,
    private renderer: Renderer2,
    private paymentsService: PaymentsService,
    private scoreLocalService: ScoreLocalService,
    private communityBridge: CommunityBridgeService,
    // Injected so the native-bridge receiver (window.__flipBridgeResult) is registered from app
    // boot, before any purchase screen asks for it.
    private nativeBridge: NativeBridgeService,
    private communityWarmupService: CommunityWarmupService,
    private communityPromoModalService: CommunityPromoModalService,
    private communityWelcome: CM01CommunityWelcomeService,
    private updateCompleteModalService: UpdateCompleteModalService,
    // Injected so navigation tracking for the global back button starts at app boot, before the
    // nav shell (and the button) become visible.
    private backNavigationService: BackNavigationService,
    // Injected for the same reason - Nova's silent screen-change context should start tracking
    // at app boot, not whenever a Nova-related component happens to be on screen.
    private novaNavigationContextService: NovaNavigationContextService,
    // Injected for the same reason again - a walkthrough's NavigationEnd match rule has to be
    // listening from app boot, since minimising Nova's dialog keeps a walkthrough running.
    private novaWalkthroughService: NovaWalkthroughService,
    private dialogNotificationService: DialogNotificationService,
    @Inject(DOCUMENT) private document: Document,
    private trackingDispatch: TrackingDispatchService,
    private versionCheckService: VersionCheckService,
    // Injected only so it is constructed, and listening to the router, before the first navigation
    // (FLIP-212). Nothing calls it.
    private routerNavigationTracker: RouterNavigationTrackerService,
    // Injected only so it is constructed at boot and listening for tab visibility (FLIP-326).
    // Nothing calls it.
    private userActivity: UserActivityService
  ) {
    // Initialize Application Insights
    //
    // A SEPARATE ApplicationInsights instance from ApplicationInsightsService's - each one
    // installs its own hook on the same global window.fetch, so excluding OpenAI on one instance
    // does nothing to stop the other from instrumenting that call. This one has
    // enableCorsCorrelation: true (needed to link this app's own frontend/backend traces, so left
    // on rather than disabled), which is exactly the setting that adds a "Request-Id" header to
    // cross-origin requests - including Nova's Realtime voice path POSTing an SDP offer straight
    // to https://api.openai.com/v1/realtime/calls. OpenAI's CORS preflight rejects that header, so
    // the browser blocked the request before it was ever sent and voice chat could not connect.
    // Excluded here too, for the same reason and with the same pattern as
    // ApplicationInsightsService.
    if (environment.appInsights.connectionString) {
      const appInsights = new ApplicationInsights({
        config: {
          connectionString: environment.appInsights.connectionString,
          enableAutoRouteTracking: true,
          enableCorsCorrelation: true,
          enableRequestHeaderTracking: true,
          enableResponseHeaderTracking: true,
          autoTrackPageVisitTime: true,
          excludeRequestFromAutoTrackingPatterns: APP_INSIGHTS_EXCLUDED_FROM_AUTO_TRACKING,
        },
      });

      appInsights.loadAppInsights();
      appInsights.trackPageView();

    }

    const routerEventSubscription = router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        // Router's scrollPositionRestoration can miss the timing on lazy-loaded
        // pages whose content resizes after NavigationEnd fires; force it here too.
        // Deferred a frame so it runs after the new route's DOM has painted,
        // otherwise Chrome's scroll anchoring can re-scroll it back down.
        requestAnimationFrame(() => window.scrollTo(0, 0));
        // check auth
        if (this.userService.isTokenExpired()) {
          this.userService.logoutOnTokenExp();
          this.router.navigate(["/login"]);
        }
        if (event instanceof NavigationEnd && (event.url.includes("/plan") || event.url.includes("/hand"))) {
          this.isPlanPage = true;
          this.zoomService.setPlanZoomButton(true);
        } else {
          this.isPlanPage = false;
          this.zoomService.setPlanZoomButton(false);
        }

        if (event instanceof NavigationEnd) {
          const isInCommunity = /^\/community(\/|\?|$)/.test(event.url);
          if (isInCommunity && !this.wasInCommunity) {
            this.communityBridge.notifyOpen();
            // FLIP-383: CM01D/CM01M welcome + the first-visit record (read-before-write).
            this.communityWelcome.enter();
          } else if (!isInCommunity && this.wasInCommunity) {
            this.communityBridge.notifyClose();
            this.communityWelcome.leave();
          }
          this.wasInCommunity = isInCommunity;

          // Nav only becomes reachable once showNav is true, so that's also the
          // earliest point warming Community is worthwhile - warm() is a one-shot
          // internally, so this is a cheap no-op check on every later navigation.
          if (this.showNav) {
            this.communityWarmupService.warm();
          }
        }

      });

    this.subscription$.add(routerEventSubscription);

    a2hs.checkUserAgent();
    a2hs.trackStandalone();
  }

  // time to disect the push subscription object

  urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, "+")
      .replace(/_/g, "/");

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  ngOnDestroy(): void {
    if (this.subscription$) {
      this.subscription$.unsubscribe();
    }
  }

  ngOnInit() {
    this.isMobileApp$ = this.mobileService.isMobileAppSubject$;

    // Global hook for the "extra top clearance inside the native app webview"
    // concern: any component's SCSS can key off `:host-context(body.is-mobile-app)`
    // (or a plain `body.is-mobile-app .foo` selector for global styles) without
    // each one repeating the MobileService DI + `isMobileApp$ | async` boilerplate.
    const mobileAppClassSubscription = this.isMobileApp$.subscribe(
      (isMobileApp) => {
        this.renderer[isMobileApp ? "addClass" : "removeClass"](
          this.document.body,
          "is-mobile-app"
        );
      }
    );
    this.subscription$.add(mobileAppClassSubscription);

    const userLoginStatusChangeSubscription =
      this.userService.userLoginStatusChanged$.subscribe(() => {
        // Refresh so the nav shell (showNav) reflects login/logout promptly, then try to
        // load authenticated data - which only actually fires once BOTH a real login and
        // a confirmed active subscription exist (see maybeLoadAuthenticatedData).
        this.cdRef.detectChanges();
        this.maybeLoadAuthenticatedData();
      });

    this.subscription$.add(userLoginStatusChangeSubscription);

    // The subscription-confirmed signal is the other half of "properly authenticated".
    // On logout it emits false - reset the one-shot guard so the next session reloads data,
    // and clear the cached categories/tags so a different user logging into this same tab
    // doesn't briefly see the previous user's custom tags.
    const subscriptionActiveSubscription =
      this.paymentsService.subscriptionActive$.subscribe((active) => {
        if (!active) {
          this.authedDataLoaded = false;
          this.scoreLocalService.clearCategories();
          this.featureFlagService.reset();
          // Stop refreshing the bell and forget it, so the next account starts clean (FLIP-467).
          this.dialogNotificationService.reset();
          return;
        }
        this.maybeLoadAuthenticatedData();
      });

    this.subscription$.add(subscriptionActiveSubscription);

    // Score Reminder / Science Bite notifications are scheduled on the server (FLIP-436) and the bell
    // reads them from there (FLIP-467), so nothing here reschedules when the user edits their alert
    // times: the settings save re-syncs the server's schedule itself. The bell is started once, at
    // login, in maybeLoadAuthenticatedData().

    this.listenToLoading();
    this.setupServiceWorkerMessageListener();

    // Setup native push notification communication
    // This will send initial status when settings are loaded
    this.nativePushNotificationService.setupNativeCommunication();

    // Re-activated after being lost as collateral when NavigationFooterComponent
    // (the old app-shell component that used to own this call) was deleted - see
    // FLIP-77. Started here instead so it fires on every app boot regardless of
    // the nav shell being visible.
    this.versionCheckService.initVersionCheck(environment.versionCheckURL);
  }

  /**
   * Sets up a listener for messages from the service worker
   * Handles navigation requests from push notification clicks
   */
  setupServiceWorkerMessageListener() {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data && event.data.type === "NAVIGATE") {
          const url = event.data.url;
          if (isAppPath(url)) {
            // Pass state indicating this navigation is from a notification
            // This allows components to detect and handle notification clicks
            const notificationType = notificationTypeFromUrl(url);

            // Tapping a push only navigates. The matching bell entry stays until the user dismisses it (its X
            // or its action button); the server drops it on its own once the user has done what it asked.

            // navigateByUrl, not navigate([url]): the url can carry a query (FLIP-475's
            // "/community?post=..."), which navigate() would take as one path segment and encode.
            this.router
              .navigateByUrl(url, {
                state: {
                  fromNotification: true,
                  notificationType: notificationType,
                },
              })
              .then((success) => {
              })
              .catch((error) => {
                console.error("[App] Navigation error:", error);
              });
          } else {
            console.warn("[App] Navigation message has no URL, or one outside the app:", url);
          }
        } else if (event.data && event.data.type === "COMMUNITY_NOTIFICATION") {
          // FLIP-161 / FLIP-470: a Community (NodeBB) push arrived while this tab is open. The entry is
          // already on the server (it is written before the push is sent), so refresh the bell to show it
          // now. Nothing is built from the message itself any more - see
          // DialogNotificationService.onCommunityPushReceived().
          this.dialogNotificationService.onCommunityPushReceived();
        } else {
        }
      });
    } else {
      console.warn("[App] Service worker not supported in navigator");
    }
  }

  get isLoggedIn() {
    return this.userService.isUserLoggedIn();
  }

  /**
   * Loads authenticated data (cards, plans, settings, score categories, notification
   * schedule) exactly once, but ONLY when the user is both really logged in (currentUser
   * present) AND has a
   * confirmed active subscription. Called from both the login and subscription-confirmed
   * signals because they can arrive in either order - reload: login first, then the sub
   * check; registration: subscription marked active at payment-success while still "pending",
   * then login on Continue. Gating on isUserLoggedIn() also prevents running during the
   * pending-auth phase, where getUser() is still null and the fan-out would crash.
   */
  private maybeLoadAuthenticatedData() {
    if (this.authedDataLoaded) {
      return;
    }
    if (
      this.userService.isUserLoggedIn() &&
      this.paymentsService.isConfirmedActive
    ) {
      this.authedDataLoaded = true;
      this.cardService.init();
      this.homeService.init();
      this.featureFlagService.init();
      this.settingsLocalService.init();
      this.scoreLocalService.getCategories();
      // The bell is built on the server from the notification log (FLIP-467): load it now and keep it
      // fresh while the app is open.
      this.dialogNotificationService.init();
      // Guarded on isOnboardingComplete() so a brand-new user - already logged in and
      // subscribed while still mid-onboarding - doesn't get the promo here before they've
      // finished; that path is handled explicitly by onboarding-flow's finishOnboarding().
      if (this.userService.isOnboardingComplete()) {
        this.communityPromoModalService.maybeShow();
        // FLIP-79/81: covers all three arrival routes onto a new version (Update now,
        // snooze re-show, fresh open) from this single call site - see
        // UpdateCompleteModalService for why.
        this.updateCompleteModalService.checkAndMaybeShow();
      }
      this.cdRef.detectChanges();
    }
  }

  /**
   * Keeps the main nav hidden until the user is logged in, past onboarding, AND has a
   * confirmed active subscription - so the nav (and the ScoreLocalService construction it
   * triggers) stays hidden for a stale/unconfirmed session.
   */
  get showNav() {
    return (
      this.isLoggedIn &&
      this.userService.isOnboardingComplete() &&
      this.paymentsService.isConfirmedActive
    );
  }

  logout() {
    const logoutSubscription = this.accountService.logout().subscribe(
      (result) => {
        if (result) {
          this.isMobileApp$.subscribe((isMobileApp) => {
            if (isMobileApp) {
              // DON'T TOUCH following line, needed for the flutter app logout
              console.log("flutterAppLogoutEvent");
            } else {
              this.userService.logoutUser();
              this.router.navigate(["/login"]);
            }
          });
        } else {
          alert("There are some problems, please, try again");
        }
      },
      (error) => {
        alert("There are some problems, please, try again");
        console.log(error);
      }
    );

    this.subscription$.add(logoutSubscription);
  }

  /**
   * Listen to the loadingSub property in the LoadingService class. This drives the
   * display of the loading spinner.
   */
  listenToLoading(): void {
    this.loadingService.loadingSub
      .pipe(delay(0)) // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
      .subscribe((isLoading) => {
        this.isLoading = isLoading;
      });
  }

  ngAfterViewInit(): void {
    const queryParamsSubscription = this.route.queryParams.subscribe(
      (params) => {
        if (params["appPlatform"]) {
          this.mobileService.setPlatformType(params["appPlatform"]);
        }
      }
    );

    this.subscription$.add(queryParamsSubscription);

    // check if we are in the WebView
    window.addEventListener(
      "flutterInAppWebViewPlatformReady",
      function (event) {
        this.isFlutterInAppWebViewReady = true;
      }
    );

    // Warm the large hero images of the main screens after first paint, so navigating
    // between screens paints from cache instead of downloading + decoding on arrival.
    const warm = () => this.imagePreloadService.warmHeroImages();
    if ("requestIdleCallback" in window) {
      (window as any).requestIdleCallback(warm, { timeout: 3000 });
    } else {
      setTimeout(warm, 1500);
    }
  }
}
